import React from 'react';

import { getEventDateTimeData } from './utils';

import styles from './styles.module.scss';

const EventDateTime = ({ event }) => {
  const { starting_at, ending_at } = event;

  const { startDay, startMonth, startTime } = getEventDateTimeData(
    starting_at,
    'start'
  );

  const { endDay, endMonth } = getEventDateTimeData(ending_at, 'end');

  return (
    <div className={styles.eventDatetimeWrapper}>
      <div className={styles.day}>
        {startDay}
        {endDay && endDay !== startDay && ` - ${endDay}`}
      </div>
      <div className={styles.month}>
        {startMonth}
        {endMonth && endMonth !== startMonth && ` - ${endMonth}`}
      </div>
      <div className={styles.divider} />
      <div className={styles.time}>{startTime}</div>
    </div>
  );
};

export default EventDateTime;
